import { Grid } from "@material-ui/core"
import CbCategoria from "../cbCategoria"
import CbPaquete from "../cbPaquetes"
import FieldSalida from "./FieldFechaSalida"
import FieldCatalogoExtras from "./FieldCatalogoExtras"
import FieldAdultos from "./FieldAdultos"
import FieldMenores from "./FieldMenores"
import FieldInfantes from "./FieldInfantes"
import FieldIndividual from "./FieldIndividual"
import FieldMetodoPago from "./FieldMetodoPago"
import { useSelector } from "react-redux"
import FieldDescuento from "./FieldDescuento"
const FCotizacion = () => {
    const { update } = useSelector(store => store.cotizador)
    return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container>
                        {
                            (!update) &&
                            <Grid item xs={12} style={{margin: "2px 0"}}>
                                <CbCategoria />
                            </Grid>
                        }
                        {
                            (!update) &&
                            <Grid item xs={12} style={{margin: "2px 0"}}>
                                <CbPaquete />
                            </Grid>
                        }

                        <Grid item xs={12} style={{margin: "2px 0"}}>
                            <FieldSalida />
                        </Grid>
                        <Grid item xs={4} style={{margin: "2px 0"}}>
                            <FieldAdultos />
                        </Grid>
                        <Grid item xs={4} style={{margin: "2px 0"}}>
                            <FieldMenores />
                        </Grid>
                        <Grid item xs={4} style={{margin: "2px 0"}}>
                            <FieldInfantes />
                        </Grid>
                        <Grid item xs={12} style={{margin: "2px 0"}}>
                            <FieldIndividual />
                        </Grid>
                        <Grid item xs={12} style={{margin: "2px 0"}}>
                            <FieldMetodoPago />
                        </Grid>
                        <Grid item xs={12} style={{margin: "2px 0"}}>
                            <FieldDescuento />
                        </Grid>
                        <Grid item xs={12} style={{margin: "2px 0"}}>
                            <FieldCatalogoExtras />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
export default FCotizacion